import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MESSAGES_REPOSITORY } from './repositories/IMessages.repository';
import { MessagesRepository } from './repositories/messages.repository';
import { MESSAGES_SERVICE } from './services/IMessages.service';
import { MessagesService } from './services/messages.service';
import { GbmConversationsEffects } from './state/effects/gbmConversations.effects';
import { NotificationsEffects } from './state/effects/notifications.effects';
import { LeadsEffects } from './state/effects/leads.effects';
import { ReviewsEffects } from './state/effects/reviews.effects';
import { MessagesEffects } from './state/messages.effects';
import { messagesReducer } from './state/messages.reducer';
import { MESSAGES_STORE_KEY } from './state/messages.selectors';
import { MessagesStore } from './state/messages.store';
import { GbmConversationsStore } from './state/store/gbmConversations.store';
import { NotificationsStore } from './state/store/notifications.store';
import { LeadsStore } from './state/store/leads.store';
import { ReviewsStore } from './state/store/reviews.store';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forFeature(MESSAGES_STORE_KEY, messagesReducer),
    EffectsModule.forFeature([
      MessagesEffects,
      GbmConversationsEffects,
      LeadsEffects,
      ReviewsEffects,
      NotificationsEffects
    ]),
  ],
  exports: [],
})
export class MessagesCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<MessagesCoreModule> {
    return {
      ngModule: MessagesCoreModule,
      providers: [
        { provide: MESSAGES_SERVICE, useClass: MessagesService },
        { provide: MESSAGES_REPOSITORY, useClass: MessagesRepository },
        ...(config?.providers || []),
        MessagesStore,
        GbmConversationsStore,
        LeadsStore,
        ReviewsStore,
        NotificationsStore
      ],
    };
  }
}
